import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DONATE } from "@/constants/testIds";
import { usePaymentStatusPolling } from "@/hooks/usePaymentStatusPolling";

export default function DonateSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const { status, amount, frequency } = usePaymentStatusPolling(sessionId);

  return (
    <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
      {status === "checking" && (
        <div data-testid={DONATE.statusPending}>
          <div className="h-10 w-10 border-2 border-zinc-300 border-t-zinc-950 rounded-full animate-spin mx-auto mb-6" />
          <p className="text-zinc-500">Confirming your donation...</p>
        </div>
      )}
      {status === "paid" && (
        <div data-testid={DONATE.successMessage}>
          <CheckCircle2 className="h-16 w-16 text-[#1E3A6E] mx-auto mb-6" />
          <h1 className="font-display font-extrabold uppercase text-2xl text-zinc-950 mb-3">Thank You</h1>
          <p className="text-zinc-600 mb-8">
            Your {frequency === "monthly" ? "monthly donation" : "donation"} of ${amount?.toFixed(2)}{frequency === "monthly" ? "/month" : ""} is
            helping us build a safer, more accountable world. Every dollar moves BERN and our advocacy work
            closer to reality.
          </p>
          <Link to="/"><Button className="bg-zinc-950 text-white rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">Back to Home</Button></Link>
        </div>
      )}
      {(status === "expired" || status === "timeout" || status === "error") && (
        <div>
          <XCircle className="h-16 w-16 text-red-500 mx-auto mb-6" />
          <h1 className="font-display font-extrabold uppercase text-2xl text-zinc-950 mb-3">
            {status === "expired" ? "Session Expired" : "We couldn't confirm your payment"}
          </h1>
          <p className="text-zinc-600 mb-8">If money was taken from your account, check your email for a Stripe receipt. Otherwise, feel free to try again.</p>
          <Link to="/donate"><Button variant="outline" className="border-zinc-300 text-zinc-950 rounded-none hover:border-zinc-950">Try Again</Button></Link>
        </div>
      )}
    </div>
  );
}
